module.exports = __webpack_public_path__ + "static/media/rocket-image.3aa0b01f.png";